/** sessionStorage keys for dismissible dev overlays (cleared when the tab closes). */
export const DEV_DEVICE_QR_DISMISS_KEY = "csk-dev-device-qr-dismissed";
export const DEV_MESSAGING_WARNINGS_DISMISS_KEY =
  "csk-dev-messaging-warnings-dismissed";
export const DEV_MESSAGING_IN_PROGRESS_DISMISS_KEY =
  "csk-dev-messaging-in-progress-dismissed";
export const DEV_MESSAGING_PASSED_DISMISS_KEY =
  "csk-dev-messaging-passed-dismissed";

export function readDevPanelDismissed(key: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return sessionStorage.getItem(key) === "1";
}

export function writeDevPanelDismissed(key: string): void {
  sessionStorage.setItem(key, "1");
}
